module.exports = `<div style="white-space: pre-wrap;word-break: break-word;">第１条（目的）   
SCALES（以下、「弊社」といいます）は「SCALES」という名称により、会員として登録されたお客様との間で会員間の暗号資産の交換等の取引を行うサービスを提供致します。
本規約は、お客様が弊社との間で「SCALES」に係る取引（以下、「本取引」といいます）をされる場合の手続き及び契約内容等を規定するものです。    
 

第２条（定義） 
1. 「SCALES」とは、暗号資産のユーザー間取引及び、暗号資産と法定通貨の個人相対取引の仲介を行うサービスを提供するプラットフォームの事を言います。 
 
2. 「本会員規約」とは、本取引に係るサービスを受けるために必要なものとして、第３条に基づきお客様と弊社との間で締結される契約をいいます。また、「会員」とは弊社と本会員契約を締結したお客様をいいます。 
 
3. 「暗号資産取引所」 (以下、「取引所」といいます)とは、SCALES のサービスを受ける為に必要な Web 上にある会員ページであり、登録、申込、情報の閲覧、入金、出金、アフィリエイト等を行う事ができるものをいいます。 
 
4. 「Sustainable Exchange Service」(以下、「SES」といいます)とは、サブアカウント提供企業への口座開設に係る KYC の提出及び申請、審査に係る事務代行の事及び、下記項目に記載する「個人相対取引サポート」の事をいいます。 
 
5. 「個人相対取引サポート」とは、相対業者とお客様との暗号資産と法定通貨の交換サポートを行うサービスをいいます。 
 

第３条(契約の申込み及び成立)   
1. 会員になることを希望されるお客様は、本契約を承諾のうえ、弊社に対し所定の申込方法でインターネット上に開設する申込用のウェブサイトから所定の申込データを送信する方法により、本会員契約を申し込むものとします。 
 
2. 第１項の申込みに際し、弊社は本人確認書類の提出を求める等、弊社所定の方法を持って、申込者がお客様ご本人である事の確認をさせて頂く場合があります。 
 

第４条（契約期間） 
1. 本会員契約の契約期間は、本会員契約成立日からとし会員が本取引を終了しサービスの利用を止めた日または、弊社から本サービスの提供を終了した日までとします。 
 
 
第５条（ご利用可能な取引）  
1. 会員は SCALES について、以下の内容を行う事ができます。各内容は、本規約に定める所によります。
 (１)暗号資産取引
 (２)SES の利用
 (３)サブアカウント提供企業への口座開設
 (４)入金申請
 (５)出金申請
 (６)アフィリエイト 
 
2. 本取引やその変更の申込みについては、弊社がこれを承諾する事により効力が生じます。  
 
 
第６条（暗号資産取引について） 
1. 暗号資産取引に関して、会員間同士で任意の価格を申し込む事により、取引所指定のペア同士での暗号資産の交換を行う事ができる物とします。 

2. 取引に関して会員は自己の責任の元、価格、交換数量を指定し交換を行う物であり、それに対し取引所が定めた取引手数料の支払いを行う物とする。 
 
 
第７条(暗号資産の入金と出金について) 
1. 会員は取引所指定のアドレスへ暗号資産を自己の責任の元送金する物とし、アドレスの確認不足、入力ミスなどによる誤送金に関して、取引所は一切の責任を負わない。 
 
2. 会員は取引所の個人アカウントから、独自に任意で指定した先へ暗号資産を送金させる事ができる。また、取引所は取り扱い暗号通貨毎に最低出金金額を別途定め、その金額以下の暗号資産は出金ができない物とする。会員は出金の際に指定アドレスの入力ミス、操作ミスなどにより損害を被った場合には取引所はその責任を一切負わない物とする。 
 
 
第８条(SES について) 
会員は SES について下記の内容のサービスを受ける事ができる。 

1. 会員は弊社所定の費用を支払う事でサブアカウント提供企業への口座開設、およびデビットカード購入の申込みを行う事ができる。 

2. 両替所から弊社所定のフォームで暗号資産の交換申請を行い、所定の手続きの実行、手数料を支払う事で相対業者と法定通貨の交換サポートを受ける事ができる。 

3. 弊社はサブアカウント提供企業への申請代行を行う為、申請に必要な個人情報、KYC 情報を会員から提供を受ける事ができる。 

4. サブアカウント提供企業への申請後の審査結果について、弊社は一切の責任を負わない物とする。またサブアカウント提供企業の審査基準に関しては、弊社は一切関知しない物とする。 

5. サブアカウント提供企業への申請の結果、口座開設が不可の判定となった場合には、弊社はサブアカウント提供企業より審査手数料を除いて返金された USD を会員の両替所アカウントに返却するものとする。 

6. サブアカウント提供企業のサービス内容の変更や、英国の法令変更によるサービス内容の変更に関して、弊社は一切の責任を負わない物とする。 
 
 
第９条(SES への入金方法に関して) 
1. 会員は両替所への入金に関しては、BTC を使用し入金するものとする。 
入金時の USD/BTC レートは両替所の個人アカウントページ上に表示されているレートが基準となり BTC を所定のアドレスに送金し、送金後の TXID と送金画面のキャプチャ画像を両替所所定のフォームから提出して入金申請を行うものとする。 
 
 
第１０条(出金方法について) 
1. 会員は両替所の個人アカウントページからの出金方法について弊社の定めるフォーマットから所定の手順を経て出金申請を行うものとする。 

2. 弊社は会員から弊社所定のフォームにより指定された通貨によって、予め会員が指定している先への出金作業を行うものとする。 

3. 出金する際の手数料は出金金額の２％とする。また、手数料に関しては、ユーザーへの説明無く、SCALES が自由に変更できる物とする。 
 
 
第１１条(手数料について) 
1. 会員は第８条２項に定める内容に基づき、SES を利用する際に所定の手数料を支払う事でサービスの利用ができる。手数料に関しては以下の項目で定める物とし、その内容を SCALES は会員の了承なく自由に変更できる物とする。 
 
2. 手数料に関しては、相対申請金額の３％とする。また、手数料に関しては、 ユーザーへの説明無く、SCALES が自由に変更できる物とする。 
 
 
第１２条(会員 ID およびパスワードの管理) 
会員は自らの責任において、自らの会員 ID・パスワードを管理するものとします。
会員 ID・パスワードの第三者への貸与、譲渡に関して弊社では一切関知致しません。また、前記の管理が不十分であった事に起因する損害や、第三者の不正使用に起因する損害について、弊社は一切の責任を負いません。 
 
 
第１３条(本人確認) 
1. 弊社は、本会員契約または本会員契約に基づく個別契約の締結、その他、本規約または付帯規程に基づく取引を行うにあたり、本人確認の必要がある時、または行政手続きにおける特定の個人を識別するための番号の利用等に関する法律、その他関係法令に従い個人番号等の取得の必要があるときは、お客様または会員に対し弊社指定の書類の提出を求める事が出来ます。 

2. 前項の書類の提出等を受けられない場合、その他会員の本人確認が出来ないと弊社が判断した場合、弊社は本取引をお断りし、または本規約もしくは付帯規程に基づく弊社の義務の全部もしくは一部の履行を停止することができるものとし、この事について弊社は一切の責任を負わないものとします。 
 
 
第１４条(禁止行為) 会員は本サービス上、又は本サービスを利用して以下の行為を行ってはなりません。
1. 公序良俗または法令に違反する行為またはその恐れがある行為。

2. 他の会員または第三者の迷惑あるいは不利益を与える行為。

3. 弊社またはその他の権利者の著作権、商標権その他の権利を侵害する行為または、その恐れがある行為。 

4. 手段を問わず、本サービスの運営を妨害する行為。

5. 会員 ID 及びパスワードを不正に使用する行為。

6. その他、弊社が不適当と判断する行為。 
 
 
第１５条(禁止処分)  
1. 会員は、弊社の承諾無くして、本会員契約または本会員契約に基づく個別契約上の地位、または付帯契約に基づく一切の権利義務について、第三者へ担保提供、利用許諾その他一切の処分をする事は出来ません。 

2. 弊社は、会員が前項に違反した事により生じた損害、紛争などについ て、一切の責任をおいません。 
 
 
第１６条(届け出)  
1. 会員は、以下の場合には、直ちに弊社に届け出て弊社所定の手続きを取るものとします。
 (a)氏名、住所、電話番号、登録金融機関口座その他弊社の届出事項に変更等があった場合。 
 (b)裁判所の審判により補助・保佐・後見が開始された場合、または任意後見監督人の選任がされた場合。（既に補助・保佐・後見開始の審判を受けている場合、または任意後見監督人の選任がなされている場合を含む） 

2. 弊社は、前項の手続きがなされる前に生じた会員の損害について、一切の責任を負いません。 
 
 
第１７条(弊社からの通知) 弊社から会員への通知またはメールの送付は、会員から届出のあったメールアドレスに宛てて行うものとし、前条に基づく届出を怠った事、その他会員の責めに帰すべき事由により、弊社から通知または送付文章が延着した、又は到着しなかった場合は、通常到着すべき時に会員に到着したものと見なします。 


第１８条(申込みの撤回などの制限) 
1. 会員は、本会員契約または本会員契約に基づく個別契約、その他本規約または付帯規程に基づく取引の一切について、申込の撤回、契約の解除等を行うことは支払日起算３日以降出来ません。 

2. 弊社は、本会員契約または本会員契約に基づく個別契約、その他本規約または付帯規程に基づく取引の一切について、支払日起算３日以降の契約の解除などを行う事はできません。 
 
 
第１９条(精算)  
1. 本会員契約の終了に際し、購入金額及び報酬額の引出しに要する費用、手数料、口座管理料、その他会員が弊社に支払うべき金銭で未払いもの物がある場合、弊社は預り金の残高があればこれをもって支払いに充てるものとし、預かり金の残高が不足する場合には、報酬額及び購入金額から充当額をもって支払いに充てるものとします。 

2. 前各項の結果、残高がある場合、弊社は会員の指示する金融機関口座に振込み、またはアドレスに BTC 送金によりこれを返却します。この場合の振込手数料は会員の負担とします。 
 
 
第２０条(取引の制限)  
市場の急激な変動があった場合、会員と取引する事が著しく不適当と判断した場合、その他弊社がやむを得ず必要と認めた場合、弊社は本会員契約、本会員契約に基づく個別契約、その他本規約または付帯規程に基づく取引の全部または一部を制限する事ができるものとし、このことについて、弊社は一切の責任を負わないものとします。 
 
 
第２１条(取引の中止および契約の解除) 
1. 会員または代理人が以下の各号の一つにでも該当する場合、弊社は本会員契約、本会員契約に基づく個別契約、その他本規約または付帯規程に基づく取引の全部または一部を直ちに中止することができるものとし、このことについて、弊社は一切の責任を負わないものとします。 
 a)弊社への届出事項につき虚偽の届出をしたとき、または弊社への提出資料が真正でないことが判明した時。 
 b)本会員契約、本会員契約に基づく個別契約または法令等に違反した時、または違反の恐れがあると認められた時。 
 c)所在等が不明となり、弊社からの連絡を行うことが不可能であると弊社が判断した時。 
 d)本会員契約の名義人が存在しないことが明らかになった時、または名義人の意思によらず本会員契約が締結されたことが明らかになった時。 
 e)弊社が本人確認の為に再度弊社指定の書類の提出等を求めたものの、これに応じない時(弊社が定める期日までに弊社に連絡が無い時、会員の届出住所へ発送した提出を求める通知が不着の為、弊社に返送された時、会員の届出電話番号等への連絡が取れない時等を含みます。) 
 f)決済資金または預り金の全部または一部について、犯罪行為等によって不正に取得した疑いがあると弊社が判断した時。 
 g)本取引の運営または弊社の電気通信設備に支障を及ぼし、または及ぼすおそれのある行為を行ったと弊社が判断した時。 
 h)破産、民事再生、その他債務整理手続の申立てを受けた時、または自ら申し立てた時。 
 i)仮差押、仮処分、強制執行、競売等の申立て、もしくは租税公課の滞納に係る滞納処分を受け、またはこれの申立て、処分を受ける可能性のある事由が生じた時。 
 j)その他やむを得ない事由がある時。 

2. 前項各号の一つにでも該当し、本会員契約を継続する事が不適当であると弊社が認める場合には、弊社は本会員契約を解除する事ができます。この場合、弊社は残高等ある場合の振込手数料は会員の負担とします 

3. 会員資格の解約、失効に関する規定 
３-１.会員資格を解約する場合 
会員は、希望すればいつでも会員資格を解約することができます。解約後は会員資格、その会員が受け取るすべてのサービス及び特典の権利は消滅し、メンバーページへのログインは無効となります。 
３-２．弊社の解除権 
弊社は、会員が以下の何れかに該当すると判断した場合、何ら催告を要することなくただちに、その会員登録を一方的に解除することができます。会員はこの取扱いに予め同意するものとします。 
① 会員が、ビジネスを展開する地域に適用される法律（関連法令の一切を含む）に違反し、または、犯罪など社会秩序に反する行為を行った場合。 
② 会員の健全なビジネスの継続が困難になった場合、 
③ 会員がビジネスを健全に運営するために必要なことを理解したり、必要な判断を行ったりすることができない」と弊社が判断した場合。 
④ 会員が弊社のイメージを著しく損なった場合。 
⑤ 会員が弊社又は他の会員を誹謗中傷した場合。 
⑥ 会員が弊社のビジネスに競合し又は支障を与えるビジネスを運営した場合。 
⑦ 会員が、本書面の規定に１つでも違反し、その他弊社が定める規約に１つでも違反した場合。 
⑧ 前項に定めるものの他、弊社が、その者を会員として不適当であると判断した場合。 
 
 
第２２条(不可抗力及び免責事項) 
1. 天災地変、戦争、内乱、暴動、法令の制定改廃、公権力による命令、処分、指導、争議行為、輸送機関の事故、その他の不可抗力による履行遅滞または履行不能については、弊社はその責めを負わないものとします。なお、これらの事由の発生により、本会員契約、本会員契約に基づく個別契約、その他付帯規程に基づく取引の実行ができなくなった場合には、弊社は、会員に対し何らの責めを負う事無く、弊社は取引の全部または、一部を停止もしくは中止し、または本取引に関する業務を停止もしくは中止する事ができるものとします。 

2. システムの過誤、その他の事由により弊社の表示価格が誤っていた場合、その表示価格が市場価格と著しく乖離しており、それが誤って表示されたものである事が客観的にみて明白であるときは、弊社の故意または重過失によるものでない限り、弊社は会員に対し何らの責めを負うこと無く当該表示価格を前提としてなされた取引を取り消す事ができます。 

3. 弊社が本会員契約、本会員契約に基づく個別契約、その他本規約または付帯規程に基づき会員に支払うべき金銭について、会員の登録金融機関口座に振り込んだ場合には、いかなる理由であれ、弊社は該当支払いに係る債務を免れるものとします。 
 
 
第２３条(業務の中止) 
1. 弊社は、やむを得ず本取引に関する業務の運営を継続できなくなったと弊社において判断した場合は、会員に対し何らの責めを負う事なく、本取引 に関する業務を中止する事があります。 

2. 前項の場合、弊社は原則として以下の通りの処理を行うものとします。
 (１)弊社は業務を中止した旨を会員に対し通知します。
 (２)通知方法に関しては、弊社所定の方法により通知を行う物とします。 


第２４条(約款の改定) 
1. 本規約または付帯規程は法令の変更、監督官庁の指示、その他必要が生じた時に改定される事があります。 

2. 本規約または付帯規程を改定する時は、弊社は会員に対し本約款または付帯規程を改定する旨、変更後の本規約または付帯規程の内容及び変更後の本規約または付帯規程の適用開始日を取引所への掲載その他適当と認める方法により事前に周知します。 
 
 
第２５条(罰則規定) 
会員が本規約に違反した場合、弊社は当該会員に電子メールにて通知し、違反行為を即刻やめるように要求します。また、通告と同時にボーナスの支払いを保留または停止する場合があります。更に通告後、30日を経過しても違反行為が続く場合、弊社は以下のように対処できる単独かつ絶対的権限を持ちます。 
 a) 正式な警告 
 b) ビジネス活動の停止処分 
 c) ボーナスの支払い保留または停止処分 
 d) 既払いボーナスの返還処分 
 e) 資格認定、特典等の取り消し及び返還処分 
 f) 会員資格解除処分 
 
 
第２６条(規約の改定) 
本規約は、法令の変更、監督官庁の指示もしくは命令、その他必要が生じたときは、事前に通知することなく改定または廃止することがあります。この場合、改定日以降は改定後の規約を適用し、廃止日以降は本規約の適用を終了するものとします。本規約の改定または廃止により会員または第三者に生じた損害について、当社は責任を負いません。 


２０２０ 年 ９月１日 制定
 <div/>`



// WEBPACK FOOTER //
// ./src/scripts/consts/privacyPolicy/privacyPolicy_jp.js